import React, { useState } from 'react';
import { Card } from 'reactstrap';
import { useGetCollectPaymentContext } from '../../context';
// import FullBreakupDialog from './FullBreakupDialog';
import { formattedPrice } from '../../utils';

const ViewFullBreakup = ({
     module, 
     FullBreakupDialog , 
     title="Amount to be paid"
    }) => {

    const [fullBreakupDialogOpen, setFullBreakupDialogOpen] = useState(false);
    const { amountToBePaid, selectedCharges } = useGetCollectPaymentContext(module);
    // const amountToBePaid = formattedPrice(partialAddAmount || selectedChargesAmount);

    return (
        <Card className="p-3" style={{ marginBottom: '10px' }}>
            <div className='mb-3 view-full-breakup-card-heading'>
                <span>{title}</span>
                <span className='float-right'>{formattedPrice(amountToBePaid)}</span>
            </div>

            {FullBreakupDialog &&
                <>
                    <div className='view-full-breakup-cta cursor' onClick={() => setFullBreakupDialogOpen(true)}>View full breakup</div>

                    <FullBreakupDialog
                        open={fullBreakupDialogOpen}
                        setOpen={setFullBreakupDialogOpen}
                        data={[...selectedCharges['OTHER_CHARGES'], ...selectedCharges['REGULAR_CHARGES']]}
                        amountToBePaid={amountToBePaid}
                    />
                </>
            }

        </Card>
    );
}

export default ViewFullBreakup;